/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Mixins
import settings from './settings';

import { get } from 'lodash';

// Components
import BaseInput from 'shared/ui/components/form-components/BaseInput.vue';
import BaseSelect from 'shared/ui/components/form-components/BaseSelect.vue';
import BaseTextarea from 'shared/ui/components/form-components/BaseTextarea.vue';

const __vue_script__ = {
    name: 'Labelling',

    components: { BaseInput, BaseSelect, BaseTextarea },

    mixins: [settings],

    data() {
        return {
            branding: null,
            locale: 'en',
            inAppTitle: '',
            inAppSubtitle: '',
            innerValue: {
                description: {
                    title: {},
                    subtitle: {}
                },
                i_calendar: {
                    title: '',
                    location: '',
                    description: ''
                }
            }
        };
    },

    watch: {
        inAppTitle() {
            this.innerValue.description.title[this.locale] = this.inAppTitle;
        },

        inAppSubtitle() {
            this.innerValue.description.subtitle[this.locale] = this.inAppSubtitle;
        }
    },

    methods: {
        async init() {
            this.inAppTitle = this.event.description.title?.[this.locale];
            this.inAppSubtitle = this.event.description.subtitle?.[this.locale];
            this.innerValue.i_calendar.title = this.event.i_calendar?.title || this.$utils.workspaces.getWorkspaceTitle(this.event, this.$i18n.locale);
            this.innerValue.i_calendar.location = this.event.i_calendar?.location || get(this.event, 'description.venue.city');
            this.innerValue.i_calendar.description = this.event.i_calendar?.description || '{{_webapp_link}}';
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",staticClass:"labelling",attrs:{"tag":"form","autocomplete":"off"}},[_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.in_app_display')))]),_c('validation-provider',{attrs:{"rules":"required","slim":true,"name":"title"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var errors = ref.errors;
return [_c('base-input',{attrs:{"label":_vm.$t('general_settings.form.in_app_title'),"disabled":!_vm.canChangeSettings,"type":"text","name":"title","errors":errors},model:{value:(_vm.inAppTitle),callback:function ($$v) {_vm.inAppTitle=$$v},expression:"inAppTitle"}})]}}])}),_c('validation-provider',{attrs:{"slim":true}},[_c('base-input',{attrs:{"label":_vm.$t('general_settings.form.in_app_subtitle'),"disabled":!_vm.canChangeSettings,"type":"text","name":"subtitle"},model:{value:(_vm.inAppSubtitle),callback:function ($$v) {_vm.inAppSubtitle=$$v},expression:"inAppSubtitle"}})],1)],1),_c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.$t('general_settings.section_titles.calendar')))]),_c('validation-provider',{attrs:{"slim":true}},[_c('base-input',{attrs:{"label":_vm.$t('general_settings.form.calendar_title'),"disabled":!_vm.canChangeSettings,"type":"text","name":"i_cal_title"},model:{value:(_vm.innerValue.i_calendar.title),callback:function ($$v) {_vm.$set(_vm.innerValue.i_calendar, "title", $$v)},expression:"innerValue.i_calendar.title"}})],1),_c('validation-provider',{attrs:{"slim":true}},[_c('base-input',{attrs:{"label":_vm.$t('general_settings.form.calendar_location'),"disabled":!_vm.canChangeSettings,"type":"text","name":"i_cal_location"},model:{value:(_vm.innerValue.i_calendar.location),callback:function ($$v) {_vm.$set(_vm.innerValue.i_calendar, "location", $$v)},expression:"innerValue.i_calendar.location"}})],1),_c('validation-provider',{attrs:{"slim":true}},[_c('base-textarea',{attrs:{"label":_vm.$t('general_settings.form.calendar_description'),"disabled":!_vm.canChangeSettings,"name":"i_cal_description","rows":5},model:{value:(_vm.innerValue.i_calendar.description),callback:function ($$v) {_vm.$set(_vm.innerValue.i_calendar, "description", $$v)},expression:"innerValue.i_calendar.description"}})],1)],1)])}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Labelling.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__